// Follow countries & topics, with no account needed.
// Stored in the browser (localStorage), so it stays on this device only.
// When the visitor signs in (features/auth.js), the same list is synced to
// their account so it follows them to other devices.

const KEY = 'nnw:follows:v1';
const listeners = new Set();

function read() {
    try {
        const v = JSON.parse(localStorage.getItem(KEY) || '{}');
        return {
            countries: Array.isArray(v.countries) ? v.countries.filter((c) => /^[A-Z]{2}$/.test(c)) : [],
            topics: Array.isArray(v.topics) ? v.topics.filter((t) => /^[a-z-]{2,30}$/.test(t)) : [],
        };
    } catch {
        return { countries: [], topics: [] };
    }
}

let follows = read();

function save({ silent = false } = {}) {
    try {
        localStorage.setItem(KEY, JSON.stringify(follows));
    } catch {
        /* private mode: keep in memory only */
    }
    if (!silent) listeners.forEach((fn) => fn(getFollows()));
}

export function getFollows() {
    return { countries: [...follows.countries], topics: [...follows.topics] };
}

export function isFollowingCountry(iso2) {
    return follows.countries.includes(String(iso2).toUpperCase());
}

export function toggleCountry(iso2) {
    const c = String(iso2).toUpperCase();
    follows.countries = isFollowingCountry(c)
        ? follows.countries.filter((x) => x !== c)
        : [...follows.countries, c].slice(0, 50);
    save();
    return isFollowingCountry(c);
}

export function isFollowingTopic(slug) {
    return follows.topics.includes(slug);
}

export function toggleTopic(slug) {
    follows.topics = isFollowingTopic(slug)
        ? follows.topics.filter((x) => x !== slug)
        : [...follows.topics, slug].slice(0, 10);
    save();
    return isFollowingTopic(slug);
}

/** Replace the whole list (used when an account's saved follows are loaded). */
export function setFollows(next, { silent = false } = {}) {
    follows = {
        countries: [...new Set((next.countries || []).map((c) => String(c).toUpperCase()))].slice(0, 50),
        topics: [...new Set(next.topics || [])].slice(0, 10),
    };
    save({ silent });
}

export function onFollowsChange(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
}
